import { useOktaAuth } from '@okta/okta-react';
import { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';

const EMPTY_USER_DETAILS = {
  username: '',
  email: '',
  roles: [],
  BUs: [],
  gpid: ''
};

export const useOkta = () => {
  const { authState, oktaAuth } = useOktaAuth();
  const initialUserDetails =
    JSON.parse(localStorage.getItem('tpoDefaultUserDetails')) || EMPTY_USER_DETAILS;
  const [userDetails, setUserDetails] = useState(initialUserDetails);

  const setAndSaveUserDetails = (details) => {
    sessionStorage.setItem('tpoDefaultUserDetails', JSON.stringify(details));
    setUserDetails(details);
  };

  const authenticate = (redirectUri = '/') => {
    if (authState?.isAuthenticated === false) {
      oktaAuth.signInWithRedirect({ originalUri: redirectUri });
    }
  };

  useEffect(() => {
    if (authState?.isAuthenticated) {
      try {
        const token = authState.accessToken.accessToken;
        const decodedToken = jwtDecode(token);
        setAndSaveUserDetails({
          username: decodedToken.displayname,
          email: decodedToken.email,
          roles: decodedToken.pepappdtvtporoles,
          BUs: decodedToken.pepappdtvtpobu,
          gpid: decodedToken.gpid || decodedToken.GPID
        });
      } catch (error) {
        console.error('Invalid token:', error);
      }
    } else {
      setAndSaveUserDetails(EMPTY_USER_DETAILS);
    }
  }, [authState]);

  return { authState, authenticate, oktaAuth, userDetails };
};
